import React from 'react';
import { ModalWrapper } from './ModalWrapper';

interface Issue {
    issue: string;
    issue_owner?: number;
    issue_date?: number; // timestamp
}

interface IssuesModalProps {
    isOpen: boolean;
    onClose: () => void;
    issues: Issue[];
    getUserName: (userId: number) => string;
}

export const IssuesModal: React.FC<IssuesModalProps> = ({
    isOpen,
    onClose,
    issues,
    getUserName,
}) => {
    const formatDate = (timestamp: number | undefined): string => {
        if (!timestamp) return "";
        const date = new Date(timestamp);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    return (
        <ModalWrapper modalId="IssuesModal"
            isOpen={isOpen}
            onClose={onClose}
            title="Issues"
            width="!max-w-3xl"
        >
            {/* Table Container */}
            <div className="bg-[#EBF5F5] rounded-2xl overflow-hidden">
                <table className="w-full">
                    <thead>
                        <tr className="bg-[#B4D9D4]">
                            <th className="px-6 py-2 text-left text-sm font-semibold text-[#366A75]">
                                Issue
                            </th>
                            <th className="px-6 py-2 text-left text-sm font-semibold text-[#366A75]">
                                Owner
                            </th>
                            <th className="px-6 py-2 text-left text-sm font-semibold text-[#366A75]">
                                Date
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {issues.map((item, index) => (
                            <tr
                                key={index}
                                className={index % 2 === 0 ? 'bg-[#EBF5F5]' : 'bg-[#D0E7E5]'}
                            >
                                <td className="px-6 py-2">
                                    {item.issue ? (
                                        <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-orange-500 text-white">
                                            ⚠ {item.issue}
                                        </span>
                                    ) : (
                                        <span className="text-[#366A75] text-opacity-40">-</span>
                                    )}
                                </td>
                                <td className="px-6 py-2 text-sm text-[#366A75]">
                                    {item.issue_owner ? getUserName(item.issue_owner) : "-"}
                                </td>
                                <td className="px-6 py-2 text-sm text-[#366A75]">
                                    {formatDate(item.issue_date) || "-"}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </ModalWrapper>
    );
};
